/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import roleAction from '../roleAction';
import { accountManagement } from '@/api/ajax';
import { logType } from '../../config/static';

export default {
  selection: {
    type: 'selection',
    width: '55',
    reserve:true,
    reserveSelection:true,
    'reserve-selection':true,
    prop: 'selection',
    selectable(row) {
      return !row.userId || row.userId == sessionStorage.getItem('currentUserId')
    }
  },
  index: {
    width: '80px',
    label: '序号',
    type: 'index'
  },
  projectNo: {
    label: '项目编码',
    prop: 'projectNo'
  },
  projectName: {
    label: '项目名称',
    prop: 'projectName'
  },
  projectStatus: {
    label: '项目状态',
    prop: 'projectStatus',
    formatter: i =>{
      return ['未完结','已完结'][i.projectStatus]
    }
  },
  fullName: {
    label: '子账号',
    prop: 'fullName'
  },
  endDt:{
    label: '执行结束时间',
    prop: 'endDt'
  },
  startDt:{
    label: '执行开始时间',
    prop: 'startDt'
  },
  industryEnterpriseName:{
    label: '工业方名称 ',
    prop: 'industryEnterpriseName'
  },
  distributionState: {
    label: '分配状态',
    prop: 'distributionState',
    formatter: i => {
      return ['未分配', '已分配'][i.distributionState];
    }
  },
  userName: {
    label: '用户',
    prop: 'userName'
  },
  ip: {
    label: 'IP',
    prop: 'ip'
  },
  description: {
    label: '说明',
    prop: 'description'
  },
  associatedAccounts: {
    label: '已关联子账号',
    prop: 'associatedAccounts',
    render(h, ctx, row) {
      let result = row.associatedAccounts
        .map(item => {
          return item.userName;
        })
        .join(',');
      return <div style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;word-break: break-all;">{result || '-'}</div>;
    }
  },
  roleName: {
    label: '角色名称',
    prop: 'roleName'
  },
  createDt: {
    label: '创建时间',
    prop: 'createDt'
  },
  logAction: {
    label: '操作',
    prop: 'logType',
    render: (h, ctx, row) => {
      return <div>{logType[row.logType]}</div>;
    }
  },
  operate: {
    width: '120px',
    label: '操作',
    prop: 'historyProject',
    render(h, ctx, row) {
      let vm = ctx.parent;
      let modifyRole = () => {
        vm.$xrkDialog({
          title: '编辑角色',
          width: '590px',
          showCancel: true,
          showConfirm: true,
          confirmText: '确认',
          success(params) {
            if (params.confirm) {
              accountManagement
                .roleAddOrEdit({
                  type: 1,
                  roleName: params.content.roleName,
                  roleId: row.roleId
                })
                .then(() => {
                  params.content.$message.success('编辑成功');
                  params.dialog.remove();
                  ctx.parent.reGetPage();
                });
            }
          },
          $slots: {
            default: vm.$createElement(roleAction, {
              props: { actionType: 1, oldRoleName: row.roleName }
            })
          }
        });
      };
      let deleteRole = () => {
        vm.$xrkDialog({
          title: '删除角色',
          width: '40%',
          showCancel: true,
          showConfirm: true,
          confirmText: '确认',
          success(params) {
            if (params.confirm) {
              accountManagement
                .roleDelete({
                  type: 1,
                  roleId: row.roleId
                })
                .then(() => {
                  params.content.$message.success('删除成功');
                  params.dialog.remove();
                  ctx.parent.reGetPage();
                });
            }
          },
          $slots: {
            default: vm.$createElement(roleAction, {
              props: { actionType: 3, customText: '您是否要删除当前角色？' }
            })
          }
        });
      };
      return (
        <div>
          <el-button type="text" onClick={modifyRole}>
            修改
          </el-button>
          <el-button
            disabled={row.delete === 0}
            type="text"
            onClick={deleteRole}
          >
            删除
          </el-button>
        </div>
      );
    }
  }
};
